var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { find, filter, uniq, cloneDeep } from 'lodash';
export var listToTree = function (list) {
    var map = {};
    var roots = [];
    var projectRootNode = find(list, { type: 'Root' });
    var clonedList = cloneDeep(list);
    clonedList.forEach(function (node) {
        map[node.id] = node;
        node.children = [];
    });
    clonedList.forEach(function (node) {
        if (node.parentId) {
            if (node.parentId === projectRootNode.id) {
                var newNodeIndex = roots.findIndex(function (n) { return n.order >= node.order; });
                if (newNodeIndex === -1) {
                    newNodeIndex = roots.length;
                }
                roots.splice(newNodeIndex, 0, node);
            }
            else {
                var parentNode = map[node.parentId];
                var newNodeIndex = parentNode.children.findIndex(function (n) { return n.order >= node.order; });
                if (newNodeIndex === -1) {
                    newNodeIndex = parentNode.children.length;
                }
                parentNode.children.splice(newNodeIndex, 0, node);
            }
        }
    });
    return roots;
};
export var countChildren = function (parentNode) {
    var _a;
    var numberOfChildren = 0;
    if ((_a = parentNode.children) === null || _a === void 0 ? void 0 : _a.length) {
        parentNode.children.forEach(function (childNode) {
            numberOfChildren++;
            numberOfChildren += countChildren(childNode);
        });
    }
    return numberOfChildren;
};
export var getNodeAncestors = function (treeDataMap, node) {
    var ancestors = [];
    if (node === null || node === void 0 ? void 0 : node.parentId) {
        var parentNode = treeDataMap[node.parentId];
        while (!!parentNode) {
            ancestors.push(parentNode);
            parentNode = parentNode.parentId
                ? treeDataMap[parentNode.parentId]
                : null;
        }
    }
    return ancestors.reverse();
};
export var getNodeDescendants = function (treeDataMap, node) {
    var descendants = filter(Object.values(treeDataMap), function (traveresedNode) { return traveresedNode.parentId === node.id; });
    descendants.forEach(function (traveresedNode) {
        return descendants.push.apply(descendants, __spreadArray([], __read(getNodeDescendants(treeDataMap, traveresedNode)), false));
    });
    return descendants;
};
export var getTotalSelectedCount = function (selectedLocations, treeDataMap) {
    var selectedChildren = [];
    selectedLocations.forEach(function (node) {
        return selectedChildren.push.apply(selectedChildren, __spreadArray([], __read(getNodeDescendants(treeDataMap, node).map(function (_a) {
            var id = _a.id;
            return id;
        })), false));
    });
    var totalSelected = uniq(__spreadArray(__spreadArray([], __read(selectedChildren), false), __read(selectedLocations.map(function (_a) {
        var id = _a.id;
        return id;
    })), false));
    return totalSelected.length;
};
